import axios from "axios";
import { FileParams, UploadFileParams, DeleteResponse } from "../interfaces/file";
const BASIC_API_URL = "/api";

export const uploadFile = async (params: UploadFileParams): Promise<DeleteResponse> => {
  const { file, folder, suffix, defaultExt, params: extraParams } = params;
  if (!file || !suffix || !defaultExt || !extraParams) {
    console.error('[UPLOAD] Paramètres manquants ou invalides', {
      file, suffix, defaultExt, extraParams
    });
    throw new Error("Paramètres manquants ou invalides pour l'upload");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("suffix", suffix);
  formData.append("defaultExt", defaultExt);
  formData.append("params", JSON.stringify(extraParams));
  formData.append("folder", String(folder));

  try {
    const response = await axios.post(`${BASIC_API_URL}/upload/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true,
    });
    console.log('[UPLOAD] Succès', response);
    return response.data; // { message, fileName }
  } catch (error) {
    console.error('[UPLOAD] Erreur', error);
    throw error;
  }
};


export const deleteFile = async (params: FileParams): Promise<DeleteResponse> => {
  const { folder, suffix, defaultExt, params: extraParams } = params;

  try {
    const response = await axios.delete(`${BASIC_API_URL}/upload/delete`, {
      data: {
        folder,
        suffix,
        defaultExt,
        params: extraParams,
      },
      withCredentials: true,
    });
    console.log('[DELETE] Succès', response);

    return response.data;
  } catch (error) {
    console.error('[DELETE] Erreur', error);
    throw error;
  }
};


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license